import { ReactNode } from "react";
import clsx from "clsx";

interface Props {
  children: ReactNode;
  className?: string;
  color?: string;
  style?: Record<string, unknown>;
}

const Title: React.FC<Props> = ({
  children,
  className,
  color = "text-primary",
  style,
}: Props) => {
  return (
    <h4
      className={clsx("font-semibold signika leading-none", color, className)}
      style={{
        // fontSize: 51,
        ...style,
      }}
    >
      {children}
    </h4>
  );
};

export default Title;
